import _           from 'lodash';
import constants   from 'Constants';
import listService from 'ListService';

class SettingsUtil {

    // Assumes caller exposes a context.getValueForSetting() method used to remove rendunant matrix settings
    optimizeMatrix( context ){
        const mandatoryByStage = {};
        const mandatoryByRole = {};
        const allValue = context.settings.get(constants.STRING_MATRIX_FULL_ENTRY).value || context.settings.get(constants.STRING_MATRIX_FULL_ENTRY).required;
        // We will have all rules that belong on a setting or role together and count them as well

        context.settings.forEach( setting => {
            if(setting.defaultRule){ return; }
            //On the first pass it will be undefined so we assign our base object.
            const stageSetting = mandatoryByStage[setting.stageId] || {roleId:setting.roleId, stageId:setting.stageId, items:[], counts:{}};
            const roleSetting = mandatoryByRole[setting.roleId] || {roleId:setting.roleId, stageId:setting.stageId, items:[], counts:{}};

            stageSetting.items.push(setting);
            roleSetting.items.push(setting);

            stageSetting.counts[setting[context.propertyName]] = isNaN(stageSetting.counts[setting[context.propertyName]]) ? 1 : (stageSetting.counts[setting[context.propertyName]] + 1);
            roleSetting.counts[setting[context.propertyName]] = isNaN(roleSetting.counts[setting[context.propertyName]]) ? 1 : (roleSetting.counts[setting[context.propertyName]] + 1);
            mandatoryByStage[setting.stageId] = stageSetting;
            mandatoryByRole[setting.roleId] = roleSetting;
        });
        
        if(Object.keys(mandatoryByStage).length === 1 || Object.keys(mandatoryByRole).length === 1){
            return;
        }

        Object.keys(mandatoryByStage).map(key => {
            const setting = mandatoryByStage[key];
            //We need to add a general rule if a stage has more then half of the roles on the same value
            const neededNumberOfSettings = Math.ceil(context.roles.size / 2),
                stageDefaultSetting = {defaultRule:true, target:"stage", stageId:setting.stageId};

            Object.keys(setting.counts).map(countValue => {
                if((setting.counts[countValue] > 1) &&  (setting.counts[countValue] >= neededNumberOfSettings)){
                    stageDefaultSetting[context.propertyName] = countValue;
                    //avoids adding redundant rules (edge case role=all stage =all)
                    if(!context.settings.has(setting.stageId + '_all')) {
                        context.settings.set(setting.stageId + '_all', stageDefaultSetting);
                    }
                }
            });
        });

        Object.keys(mandatoryByRole).map(key => {
            const setting = mandatoryByRole[key];

            //We need to add a general rule if a role has more then half of the stages on the same value
            const neededNumberOfSettings = Math.ceil(context.stages.size / 2),
                roleDefaultSetting = {defaultRule:true, target:"role", roleId:setting.roleId};

            Object.keys(setting.counts).map(countValue => {
                if((setting.counts[countValue] > 1) &&  (setting.counts[countValue] >= neededNumberOfSettings)){
                    roleDefaultSetting[context.propertyName] = countValue;
                    if(!context.settings.has('all_' + setting.roleId)) {
                        context.settings.set('all_' + setting.roleId , roleDefaultSetting);
                    }
                }
            });
        });
        if(context.stages.size !== 1 && context.roles.size !== 1 && context.stages.has('all') && context.roles.has('all')) {

            context.stages.forEach(function (stage) {
                if (context.settings.has(stage.id + '_' + 'all')) {
                    context.roles.forEach(function (rol) {
                        if (context.settings.has('all' + '_' + rol.id)) {
                            if (context.settings.has(stage.id + '_' + rol.id)) {
                                let val1 = context.settings.get(stage.id + '_' + 'all').value || context.settings.get(stage.id + '_' + 'all').required;
                                let val2 = context.settings.get('all' + '_' + rol.id).value || context.settings.get('all' + '_' + rol.id).required;
                                let val3 = context.settings.get(stage.id + '_' + rol.id).value || context.settings.get(stage.id + '_' + rol.id).required;
                                if (val1 === val2 && val2 === val3) {
                                    context.settings.delete(stage.id + '_' + rol.id);
                                }
                            }
                        }
                    });
                }
            });
        }

       //Delete all the all_ and _all values that are the same than all_all      
       context.settings.forEach(function (setting, key) {
           if (key !== constants.STRING_MATRIX_FULL_ENTRY) {
               if (key.indexOf('_all') > -1 || key.indexOf('all_') > -1) {
                   let val = setting.value || setting.required;
                   if (val === allValue) {
                       context.settings['delete'](key);
                   }
               }
           }
       });

        context.settings.forEach(function (setting, key) {
            if (key !== constants.STRING_MATRIX_FULL_ENTRY) {
                if( key.indexOf('_all') > -1  ){
                    context.roles.forEach(function (rol) {
                        if( context.settings.has(setting.stageId + '_' + rol.id)){
                            let val1 = context.settings.get(setting.stageId + '_' + rol.id).value || context.settings.get(setting.stageId + '_' + rol.id).required;
                            let val2 = setting.value || setting.required;
                            if(val1 === val2){
                                context.settings.delete(setting.stageId + '_' + rol.id);
                             }
                        }
                    });
                }
            }
        });

        context.settings.forEach(function (setting, key) {
            if (key !== constants.STRING_MATRIX_FULL_ENTRY) {
                if( key.indexOf('all_') > -1  ){
                    context.stages.forEach(function (stage) {
                        if( context.settings.has(stage.id + '_' + setting.roleId)){
                            let val1 = context.settings.get(stage.id + '_' + setting.roleId).value || context.settings.get(stage.id + '_' + setting.roleId).required;
                            let val2 = setting.value || setting.required;
                            if( val1 === val2){
                                context.settings.delete(stage.id + '_' + setting.roleId);
                             }
                        }
                    });
                }
            }
        });

       if( ((context.settings.size -1 ) === context.roles.size * context.stages.size || context.settings.size === 1) && (context.roles.has('all_all') && context.stages.size.has('all_all'))){
          if(context.defaultValue === allValue){
             context.settings.clear();
          }else{
            const valTemp = context.settings.get(constants.STRING_MATRIX_FULL_ENTRY);
            context.settings.clear();
            context.settings.set(constants.STRING_MATRIX_FULL_ENTRY, valTemp);
          }
       }

    }

    cleanStates(settings){
        if(settings.size <= 1){
            return settings;
        }
        const stages = listService.getWorkflowStages(true);
        const roles = listService.getWorkflowRoles(true);
        if( ( settings.size <= (stages.size * roles.size) + 1 ) ){
            return settings;
        }

        let newSettings = new Map();
        settings.forEach((setting, key) => {
            if(key === constants.STRING_MATRIX_FULL_ENTRY){
                newSettings.set(key, setting);
            }
            stages.map((stage) => { 
                roles.map(role => {
                     if(key === stage.id + '_' + role.id ){
                        newSettings.set(key, setting);
                     }
                });
            });
        });

        let inividualSettingCounts = {};
        newSettings.forEach((setting, key) => {
            if (key.indexOf('all') === -1){
                inividualSettingCounts[setting['value']] = isNaN(inividualSettingCounts[setting['value']]) ? 1 : (inividualSettingCounts[setting['value']] + 1);
            }
        });
        let maxKey = _.max(Object.keys(inividualSettingCounts), function (o) { return inividualSettingCounts[o]; });
        let all = newSettings.get(constants.STRING_MATRIX_FULL_ENTRY);  
        all.value = maxKey;  

        return newSettings;
    }

}

const settingsUtil = new SettingsUtil();
export default settingsUtil;
